/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskUpdateStatus = typeof TaskUpdateStatus[keyof typeof TaskUpdateStatus] | null;


export const TaskUpdateStatus = {
  pending: 'pending',
  scheduled: 'scheduled',
  executing: 'executing',
  done: 'done',
  archived: 'archived',
  failed: 'failed',
} as const;
